<template>
  <DxPopup
    :visible="true"
    height="auto"
    :show-title="true"
    :show-close-button="true"
    title="Seleccionar Sectores"
    :drag-enabled="true"
    :hide-on-outside-click="true"
    @hiding="handleClose"
  >
    <div class="sector-selector">
      <div class="sector-selector__body">
        <div class="sector-selector__actions">
          <button
            type="button"
            class="sector-selector__actions--select-all"
            @click="selectAll"
          >
            Seleccionar todos
          </button>
          <button
            type="button"
            class="sector-selector__actions--deselect-all"
            @click="deselectAll"
          >
            Deseleccionar todos
          </button>
        </div>
        <div class="sector-selector__grid">
          <div
            v-for="sector in sectorOptions"
            :key="sector"
            class="sector-selector__cell"
            :class="{
              'sector-selector__cell--selected': selected.includes(sector),
            }"
            @click="toggleSector(sector)"
          >
            Sector {{ sector }}
          </div>
        </div>
      </div>

      <div class="sector-selector__footer">
        <div class="sector-selector__footer__content">
          <button type="button" class="standard-blue-btn" @click="handleSave">
            Aceptar
          </button>
        </div>
      </div>
    </div>
  </DxPopup>
</template>

<script>
import { DxPopup } from "devextreme-vue/popup";
export default {
  name: "SectorPopUp",
  components: {
    DxPopup,
  },
  props: {
    selectedSectorCell: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      sectorOptions: Array.from({ length: 25 }, (_, i) => i + 1),
      selected: [],
    };
  },
  watch: {
    selectedSectorCell: {
      immediate: true,
      handler(val) {
        this.selected = Array.isArray(val?.value) ? val.value.map(Number) : [];
      },
    },
  },
  methods: {
    toggleSector(sector) {
      const idx = this.selected.indexOf(sector);
      if (idx === -1) {
        this.selected.push(sector);
      } else {
        this.selected.splice(idx, 1);
      }
    },
    selectAll() {
      this.selected = [...this.sectorOptions];
    },
    deselectAll() {
      this.selected = [];
    },
    handleSave() {
      this.$emit("save", {
        ...this.selectedSectorCell,
        value: [...this.selected].sort((a, b) => a - b),
      });
    },
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./popupSelectionSelect.scss";
</style>
